import React from 'react';
import cn from '@/utils/cn';
import { iconVariant, TIconColor } from './iconVariant';
import { IconProps } from './types/IconInterface';

interface CurrencyDollarProps extends IconProps {
  color?: TIconColor;
}

const CurrencyDollar = ({ size, variant, className, color = 'green' }: CurrencyDollarProps) => (
  <svg
    className={cn(iconVariant({ size, variant, iconColor: color, className }))}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16">
    <path
      d="M6.97574 5.83084C7.12721 5.71051 7.30714 5.62301 7.5 5.56833V7.43163C7.30345 7.37582 7.12402 7.28695 6.97574 7.16916C6.71325 6.96064 6.61168 6.7153 6.61168 6.5C6.61168 6.2847 6.71325 6.03936 6.97574 5.83084Z"
      fill="currentColor"
    />
    <path
      d="M8.5 10.4411V8.55889C8.7315 8.61518 8.94252 8.71053 9.11423 8.83932C9.39853 9.05255 9.5 9.29657 9.5 9.49998C9.5 9.7034 9.39853 9.94741 9.11423 10.1606C8.94252 10.2894 8.7315 10.3848 8.5 10.4411Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5ZM8.5 4C8.5 3.72386 8.27614 3.5 8 3.5C7.72386 3.5 7.5 3.72386 7.5 4V4.54375C7.08207 4.61779 6.68355 4.78582 6.35372 5.04784C5.87881 5.4251 5.61168 5.94753 5.61168 6.5C5.61168 7.05247 5.87881 7.5749 6.35372 7.95216C6.68869 8.21826 7.08844 8.38335 7.5 8.45622V10.441C7.26856 10.3847 7.0576 10.2894 6.88592 10.1606L6.30001 9.72119C6.0791 9.5555 5.7657 9.60027 5.60001 9.82118C5.43432 10.0421 5.47908 10.3555 5.69999 10.5212L6.28591 10.9606C6.64138 11.2272 7.06529 11.3904 7.5 11.4602V12C7.5 12.2761 7.72386 12.5 8 12.5C8.27614 12.5 8.5 12.2761 8.5 12V11.4602C8.93476 11.3904 9.35873 11.2273 9.71424 10.9606C10.211 10.5881 10.5 10.0643 10.5 9.49998C10.5 8.93563 10.211 8.41188 9.71424 8.03933C9.35873 7.77269 8.93476 7.60955 8.5 7.53972V5.56838C8.69279 5.62306 8.87265 5.71055 9.02408 5.83084L9.30067 6.05057C9.51689 6.22233 9.83142 6.1863 10.0032 5.97007C10.1749 5.75385 10.1389 5.43933 9.92269 5.26756L9.64609 5.04784C9.31631 4.78586 8.91786 4.61784 8.5 4.54378V4Z"
      fill="currentColor"
    />
  </svg>
);

export default CurrencyDollar;
